<template>
  <div class="award">
    <div class="container">
      <div class="award-inside row m-auto">
        <div class="topic col col-12 col-md-7">
          <Title :title="content.title"/>
          <h2 class="text-center">{{ content.subtitle }}</h2>

          <div class="txt">
            <awardText
            :awards="award"
            v-for="(award, index) in content.awards" :key="index" />
          </div>
        </div>

        <div class="picture col col-12 col-md-5">
          <div class="pic">
            <awardPicture
            :pictures="picture"
            v-for="(picture, index) in content.pictures" :key="index" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title_darkred.vue';
import awardText from '@/components/award_text.vue';
import awardPicture from '@/components/award_picture.vue';

export default {
  props: {
    awardsArea: {
      type: Object,
      default: () => ({
        title: 'AWARD WINNING',
        subtitle: '獲獎經驗',
        awards: [
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
        ],
        pictures: [
          {
            description: '三橫一束王、大小的小、明天的明',
            picture: 'https://picsum.photos/600/400?random=11',
          },
          {
            description: '三橫一束王、大小的小、明天的明',
            picture: 'https://picsum.photos/600/400?random=12',
          },
          {
            description: '三橫一束王、大小的小、明天的明',
            picture: 'https://picsum.photos/600/400?random=13',
          },
        ],
      }),
    },
  },
  data() {
    return {
      content: this.awardsArea,
    };
  },
  components: {
    Title,
    awardText,
    awardPicture,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.award {
  margin: 50px 0;
  text-align: center;
  .container {
    .award-inside {
      .topic {
        padding: 15px;
        display: flex;
        flex-direction: column;
        h2 {
          font-size: 2rem;
          margin-bottom: 30px;
          text-align: left;
        }
      }
      .picture{
        padding: 15px;
      }
    }
  }
}
@media screen and (max-width: 600px){
  .award {
    .container {
      .award-inside {
        .topic {
          padding: 0px;
        }
        .picture{
          padding: 0px;
        }
      }
    }
  }
}
</style>
